

jQuery(document).ready(function($) {
    
    jQuery('.toggle-menu-bars').click(function(e) {
        jQuery('.menu-main-container').toggleClass('menu-open');

        // Turns hamburger into cross
        jQuery('.toggle-menu-bar__1').toggleClass('toggle-top');
        jQuery('.toggle-menu-bar__2').toggleClass('toggle-middle');
        jQuery('.toggle-menu-bar__3').toggleClass('toggle-bottom');

        e.preventDefault();
    });

    jQuery('.sub-menu-toggle').click(function(e) {
        jQuery(this).nextAll('.sub-menu:first').toggleClass('menu-open');
    });

    // Remove mobile menu stylings
    jQuery(window).resize(function() {
        if(jQuery(window).width() > 991) {
            jQuery('.sub-menu').removeClass('menu-open');
            jQuery('.menu-main-container').removeClass('menu-open');

            jQuery('.toggle-menu-bar__1').removeClass('toggle-top');
            jQuery('.toggle-menu-bar__2').removeClass('toggle-middle');
            jQuery('.toggle-menu-bar__3').removeClass('toggle-bottom');
        }
    });

    
    // Adjust positioning of submenus depending on width of screen
    let depth2 = '#primary-menu>li>.sub-menu>li>.sub-menu';
    let lastMenuItem = '#primary-menu > li:last-child>.sub-menu';
    //On load
    if(jQuery(window).width() < 1554) {
        jQuery(depth2).css('left', '-170px');
        jQuery(lastMenuItem).css('left', '-100px');
    }

    //On resize adjust position of submenus
    jQuery(window).resize(function() {
        if(jQuery(window).width() < 1554) {
            jQuery(depth2).css('left', '-170px');
            jQuery(lastMenuItem).css('left', '-100px');
        } else {
            jQuery(depth2).css('left', '170px');
            jQuery(lastMenuItem).css('left', 'unset');
        }
    });

    jQuery('.nav-tabs > li').click(function(e) {
        let tabId = e.target.id;

        // Handles .active for nav area 
        jQuery('.nav-tabs > li.active').removeClass('active');
        jQuery('.mobile-header.active').removeClass('active');

        jQuery(this).addClass('active');

        // Handles active for tab-content
        jQuery(`.tab-content>.content`).removeClass('active');
        jQuery(`.tab-content>.content[data-year="${tabId}"]`).addClass('active');
    });

    jQuery('.mobile-header').click(function(e) {
        let year = jQuery(this).data('year');

        // Handles .active for nav area 
        jQuery('.mobile-header.active').removeClass('active');
        jQuery('.nav-tabs > li.active').removeClass('active');

        jQuery(`.nav-tabs > li[data-year="${year}"]`).addClass('active');
        jQuery(this).addClass('active');

        // Handles active for tab-content
        jQuery(`.tab-content>.content`).removeClass('active');
        jQuery(`.tab-content>.content[data-year="${year}"]`).addClass('active');
    });

    if (jQuery(window).width() < 991) {
        jQuery('.mobile-header[data-year="2023"]').addClass('active');
    } else {
        jQuery('.nav-tabs > li[data-year="2023"]').addClass('active');
    }

});